<template>
    <div class="config-nav-wrap">
        <ul>
            <li @click="goOldVersion">旧版回顾</li>
            <li @click="goOther('https://www.drcnet.com.cn/')">综合版</li>
            <el-dropdown placement="top">
                <span class="el-dropdown-link">
                    <a style="color: white; cursor: pointer;font-size: 12px;">特色数据库</a>
                </span>
                <!-- 切记这里自定义了类名，不能重复 -->
                <el-dropdown-menu slot="dropdown" class="dropdownTopPbulicMenu">
                    <el-dropdown-item v-for="(item, index) in navDataBaseDropdown" :key="index"><a :href="item.toLink"
                            target="_blank ">{{
                                item.name
                            }}</a></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <li @click="goToAbout">产品介绍</li>

            <li @click="goUseMV()">使用指南</li>
            <li @click="goAuthor">作者专区</li>
            <li @click="goPeriodical">期刊专区</li>
            <li @click="goVip">会员专区</li>
            <li @click="goHelp">帮助中心</li>
            <!-- <li class="login-register">
                <span>登录</span>
                <span>/</span>
                <span>注册</span>
            </li> -->
            <li>
                <loginComponent>
                    <template #separator1>
                        <span class="bar-style" style="margin: 0px 8px; color: red;">/</span>
                    </template>
                    <template #separator2>
                        <span class="bar-style" style="margin: 0px 8px; color: green;">/</span>
                    </template>
                </loginComponent>
            </li>
        </ul>
    </div>
</template>

<script>
import loginComponent from "@/components/LoginMinx/index.vue"
// import isMixins from '@/components/LoginMinx/index.js';
import { getOtherLibrary } from "../../api/home.js";
export default {
    components: {
        loginComponent
    },
    data() {
        return {
            menuList: [],
            navDataBaseDropdown: [
				{
					name: '国研网世界经济数据库系统',
					toLink: 'http://worldeconomy.drcnet.com.cn',
					sort: '1',
				},
				{
					name: '国研网“一带一路”研究与决策平台',
					toLink: 'http://ydyl.drcnet.com.cn',
					sort: '2',
				},
				{
					name: '经济·管理案例库平台',
					toLink: 'http://caselib.drcnet.com.cn',
					sort: '3',
				},
				{
					name: '文旅产业融合发展信息平台',
					toLink: 'http://mct.drcnet.com.cn',
					sort: '4',
				},
				{
					name: '战略性新兴产业及未来产业数据库平台',
					toLink: 'http://emerging.drcnet.com.cn',
					sort: '5',
				},
				{
					name: '数字经济发展观察与监测平台',
					toLink: 'http://szjj.drcnet.com.cn',
					sort: '6',
				},
				{
					name: '政策法规库平台',
					toLink: 'http://policy.drcnet.com.cn',
					sort: '7',
				},
                {
					name: '乡村振兴大数据画像平台',
					toLink: 'http://xchx.drcnet.com.cn',
					sort: '9',
				},
                {
					name: '30·60双碳战略研究与决策支撑平台',
					toLink: 'http://carbon.drcnet.com.cn',
					sort: '10',
				},
                {
					name: '全球智库洞察平台',
					toLink: 'https://thinktank.drcnet.com.cn/home',
					sort: '11',
				},
                {
					name: '思政信息资源平台',
					toLink: 'https://iap.drcnet.com.cn/',
					sort: '12',
				},
                {
					name: '投研数智化平台',
					toLink: 'https://tysz.drcnet.com.cn/',
					sort: '13',
				},
                {
					name: '医研数智平台',
					toLink: 'https://yysz.drcnet.com.cn/',
					sort: '14',
				},
			],
        }
    },
    created() {
        this.OtherLibraryList();
    },

    // mixins: [isMixins],
    methods: {
        goAuthor() {
            window.open('https://misc.drcnet.com.cn/DRCNet.Users.Web/Author/authorMain.aspx', "_blank")
        },
        goPeriodical() {
            window.open('https://www.drcnet.com.cn/periodical', "_blank")
        },
        goVip() {
            window.open('https://member.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx', "_blank")
        },
        goHelp() {
            window.open("https://www.drcnet.com.cn/help", "_blank")
        },
        goToAbout() {
            this.$router.push({ path: '/about' })
        },
        goOldVersion() {
            window.open('https://ovedu.drcnet.com.cn', "_blank")
        },
        goUseMV() {
            window.open("http://www.drcnet.com.cn/bayWindow/ProjectMV?title=教育版&url=http://misc.drcnet.com.cn/help/edunew.mp4", "_blank")
        },
        goOther(url) {
            window.open(url, "_blank")
        },
        OtherLibraryList() {
            getOtherLibrary().then((res) => {
                if (res) {
                    this.menuList = res.data.data;
                    console.log("99999999999999999999999999", this.menuList)
                }
            }).catch((error) => {
                console.error('获取特色库失败:', error);
            });
        },
    }
}
</script>

<style lang="less" scoped>
.config-nav-wrap {
    width: 100%;
    // height: 40px;
    height: 24px;
    background: linear-gradient(270deg, rgba(60, 117, 170, 1), rgba(23, 91, 154, 1) 65%);

    ul {
        display: flex;
        list-style: none;
        gap: 10px;
        padding: 0 30px;
        /* 左右内边距，防止贴边 */
        justify-content: flex-end;
        /* 关键：让所有 li 靠右对齐 */
        align-items: center;
        /* 垂直居中（可选） */
        height: 100%;
        /* 确保 ul 撑满父容器高度 */

        li {
            // line-height: 40px;
            color: white;
            cursor: pointer;
            /* 可选：鼠标悬停时显示手型 */

            /* 登录/注册部分的样式调整 */
            // font-size: 14px;
            font-size: 12px;

            &.login-register {
                display: flex;
                gap: 5px;
                /* 调整 "登录 / 注册" 之间的间距 */
            }
        }
    }
}

::v-deep .navigation-nav {
    .login-div {
        .toplogin {
            .nav-top {
                display: flex;
                list-style: none;
                // gap: 10px;
                padding: 0 !important;
                /* 左右内边距，防止贴边 */
                justify-content: flex-end;
                /* 关键：让所有 li 靠右对齐 */
                align-items: center;
                /* 垂直居中（可选） */
                height: 100%;

                /* 确保 ul 撑满父容器高度 */
                li {
                    list-style-type: none;
                    // line-height: 40px;
                    color: white !important;
                    cursor: pointer;
                    /* 可选：鼠标悬停时显示手型 */

                    /* 登录/注册部分的样式调整 */
                    font-size: 14px;

                    a,
                    span {
                        color: white !important;
                        // line-height: 40px !important;
                        font-size: 12px !important;
                        line-height: 24px !important;
                    }

                    &.login-register {
                        display: flex;
                        gap: 5px;
                        /* 调整 "登录 / 注册" 之间的间距 */
                    }
                }
            }
        }
    }
}

.el-popper.dropdownTopPbulicMenu {
    // top: 67px !important;
    background-color: rgba(255, 255, 255, 1); // 背景颜色
    border: 1px #c9def3 solid;

    .el-dropdown-menu__item {
        a {
            //下拉列表中的a标签样式
            color: inherit;
            /* 继承父元素的文字颜色 */
            text-decoration: none;
            /* 去除下划线 */
        }

        border-bottom: 1px solid #e6e4e3;
    }

    .el-dropdown-menu__item:last-of-type {
        border-bottom: none !important;
    }

    // .popper__arrow::after {
    // 	border-bottom-color: #0f93ee !important;
    // 	border-top-color: #0f93ee !important;
    // }
    // .el-dropdown-menu__item:not(.is-disabled):hover {
    // 	background: #40a8ee !important;
    // }
}
</style>
